import React, { useEffect, useState } from "react";
import { FaRegEdit } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import EditKnowledgeInsight from "./EditKnowledgeInsightArticle";

const ViewKnowledgeInsight = () => {
  const navigate = useNavigate();

  const { state } = useLocation();
    const [show, setShow] = useState(false);

  const [iState, setUpdate] = useState([]);
  const [StateForUpdate,setStateForUpdate] = useState([]);

  useEffect(() => {
    setUpdate(state);
  }, [state]);

  console.log(state);

  return (
    <>
      <div>

        <div>
          <div>
            <div>
              <div className="TitleBox">
                <h4 className="Title">Content Management</h4>
               
              </div>
              
              <div className="TitleBox">
                <a className="TitleLink" onClick={() => navigate(-1)}>
                  <i className="fa fa-arrow-left" /> Back
                </a>
                <a className="TitleLink" onClick={() => setShow((prev)=>!prev)}>
                  Edit
                </a>
              </div>
              <div className="Small-Wrapper">
        {/* <div class="TitleBox"> 
              <h4 class="Title">Add News Article</h4> 
          </div> */}
        <div className="CommonForm">
          <h4>ADD QuixSense</h4>
          <div
            className="row"
            style={{ display: "flex", flexDirection: "column" }}
          >
            <div>
              <div
                style={{
                  display: "flex",
                  marginBottom: "20px",
                }}
              >
                <div className="col-sm-12">
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <label>News title</label>
                        <input
                          type="text"
                          className="form-control"
                          value={iState?.title}
                          name="title"
                          disabled
                          placeholder="Enter News title..."
                        />
                      </div>
                    </div>

                    <div className="col-sm-12">
                      <div className="form-group">
                        <label>News Description</label>
                        <textarea
                          type="text"
                          className="form-control"
                          value={iState?.description}
                          disabled
                          name="description"
                          placeholder="Enter News ..."
                        />
                      </div>
                    </div>
                  </div>
                </div>
            </div>
          </div>
        </div>
        <div style={{display:'flex', width:'100%', flexWrap:'wrap', gap:'10px'}}>
        { Array.isArray(iState?.images) && iState?.images?.map((item) => {
          return(
            <div style={{height:'200px',width:'200px'}}>
           <img src={item} alt="" className="w-100 h-100" srcset="" />
            </div>
          )
        })}
      </div>
      </div>
            </div>
          </div>
        </div>
      </div>
      <EditKnowledgeInsight StateForUpdate={iState} show={show} setUpdateView={setUpdate} setShow={setShow}/>
      </div>    
    </>
  );
}


export default ViewKnowledgeInsight;
